export const userActions = {
  MENU_USER: 'MENU_USER',
  MENU_ROLE: 'MENU_ROLE',
  MENU_DECISION: 'MENU_DECISION',
  MENU_DECISION_TYPE: 'MENU_DECISION_TYPE',
  MENU_SIGNET: 'MENU_SIGNET',
  MENU_CODEBOOKS: 'MENU_CODEBOOKS',
  MENU_REQUESTS: 'MENU_REQUESTS',
  MENU_REQUEST_FOR_SIGNET_APPROVAL: 'MENU_REQUEST_FOR_SIGNET_APPROVAL',
  MENU_REQUEST_FOR_SIGNET_STATUS: 'MENU_REQUEST_FOR_SIGNET_STATUS',
  MENU_SERVICES: 'MENU_SERVICES',
  REQUEST_FOR_SIGNET_APPROVAL_PROCESSING_VIEW:
    'REQUEST_FOR_SIGNET_APPROVAL_PROCESSING_VIEW',
  SIGNET_PROCESSING_VIEW: 'SIGNET_PROCESSING_VIEW',
  MENU_KJS: 'MENU_KJS',
  MENU_PLACE: 'MENU_PLACE',
  MENU_SIGNET_EXAMPLES: 'MENU_SIGNET_EXAMPLES',
  MENU_MUNICIPALITY: 'MENU_MUNICIPALITY',
};
